<template>
  <div class="percent-component-container">
    <div class="meter-container">
      <div class="title-header-row">
        <span class="title">Total</span>
        <span class="pill-container">
          <count-pill
            :count="totalCorrect"
            icon-name="check"
            variant="00b46d"
            start
          >
            {{ totalCorrect }}
          </count-pill>
          <count-pill
            :count="totalIncorrect"
            icon-name="cross"
            variant="dc3416"
            end
          >
            {{ totalIncorrect }}
          </count-pill>
        </span>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="201"
        height="157"
        viewBox="0 0 201 157"
      >
        <defs>
          <linearGradient
            id="gradient"
            x1="9.744%"
            x2="89.39%"
            y1="100%"
            y2="100%"
          >
            <stop
              offset="0%"
              stop-color="#FB7E7A"
            />
            <stop
              offset="99.984%"
              stop-color="#7BD56E"
            />
          </linearGradient>
        </defs>
        <path
          fill="url(#gradient)"
          fill-rule="nonzero"
          d="M175.46 148.153c.245-.63.547-1.247.907-1.846C184.592 132.633 189 116.974 189 100.638 189 51.681 149.374 12 100.5 12S12 51.68 12 100.638c0 16.33 4.405 31.984 12.625 45.655.358.595.658 1.21.903 1.836.459.848.72 1.82.722 2.851.062.499.093.999.092 1.497h-.277A6.004 6.004 0 0 1 20.25 157a6.004 6.004 0 0 1-5.815-4.524h-.094C5.237 137.336 0 119.6 0 100.638 0 45.058 44.995 0 100.5 0S201 45.057 201 100.638c0 18.968-5.24 36.71-14.35 51.855h-.089A6.004 6.004 0 0 1 180.75 157a6.004 6.004 0 0 1-5.811-4.508h-.291c0-.525.033-1.052.102-1.576a5.988 5.988 0 0 1 .71-2.763z"
        />
        <g
          class="meter"
          :style="{transform: transform}"
        >
          <ellipse
            cx="12"
            cy="12.019"
            fill="#CBCED1"
            rx="12"
            ry="12.019"
          />
          <ellipse
            cx="12"
            cy="12.019"
            fill="#273142"
            rx="6.75"
            ry="6.761"
          />
          <path d="M69.75 14.273L12.063 18.78 12 5.258l57.75 4.508z" />
          <ellipse
            cx="69.75"
            cy="12.019"
            fill="#273142"
            rx="2.25"
            ry="2.254"
          />
        </g>
      </svg>
      <div class="text">
        <div>{{ percent }}%</div>
        <div>
          Percent Correct
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountPill from './CountPill.vue';

export default {
  name: 'PercentCorrect',
  components: {
    CountPill,
  },
  props: {
    percent: {
      type: Number,
      default: 0,
    },
    totalCorrect: {
      type: Number,
      default: 0,
    },
    totalIncorrect: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    transform() {
      const degrees = 140 + ((400 - 140) * (this.percent / 100));
      return `translate(88px, 82px) rotate(${degrees}deg)`;
    },
  },
};
</script>

<style lang='scss' scoped>
.percent-component-container {
  flex: 0;
  margin-bottom: rem-calc(24);

  .meter-container {
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: rem-calc(32) rem-calc(36);
  }

  .text {
    color: #354052;
    margin-top: rem-calc(-28);
    text-align: center;

    > div:first-child {
      font-size: rem-calc(48);
      font-weight: $semi-bold;
      margin-bottom: rem-calc(8);
    }

    > div:last-child {
      align-items: center;
      display: flex;
      font-size: rem-calc(20);
      justify-content: center;
    }
  }

  svg {
    margin: auto;

    .meter {
      transform-origin: 12px 12px;
      transition: transform 1s ease;

      path  {
        fill: #273142;
      }
    }
  }
}

.title-header-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: -1rem -1rem 1.6rem -1rem;
  font-size: rem-calc(12);
  font-weight: 600;
}

.pill-container {
  display: flex;
  flex-direction: row;
}
</style>
